// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard_root__d2LZQ {
  padding: 15px 40px 90px 40px;
  overflow: scroll;
  margin-right: auto;
  margin-left: auto;
  height: 80vh;
  color: var(--color-font-10);
  font-size: 16px !important;
  /* overflow-y: scroll !important; */
}

.Dashboard_upper__UIROX {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 2%;
}

.Dashboard_lower__K0ehD {
  margin-top: 2%;
}

.Dashboard_settings_icon__jrPqZ {
  width: 2%;
  margin: 1%;
  float: right;
  cursor: pointer;
}
.Dashboard_settings_icon__jrPqZ:hover {
  background-color: var(--color-bg-sidebar-item-hover) !important;
}

.Dashboard_loading_title__sez9Z {
  position: fixed;
  left: 50%;
}

.Dashboard_loading_label__pOCOG {
  position: absolute;
  left: 48%;
  margin-top: 75px;
}

.Dashboard_kpi_container__\\+kA2O {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  width: 99%;
  min-height: 150px;
}

.Dashboard_kpi_item__1JBQN {
  width: 20%;
  background-color: #fff;
  border: 1px solid #ccc;
  margin-bottom: 3%;
  cursor: pointer;
}

.Dashboard_kpi_value__hg1f3 {
  font-weight: bold;
  font-size: 35px !important;
  margin-bottom: 0% !important;
  margin-top: 4% !important;
}

.Dashboard_kpi_name__euXb3 {
  margin-top: 0% !important;
  margin-bottom: 8% !important;
}

.Dashboard_chart_filters__JkG8r {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}
.Dashboard_chart_filter__IxUgW {
  /* width: 15%; */
  margin: 0 2%;
}
.Dashboard_date_chart_filters__636uO {
  display: flex;
  margin-right: 3%;
  /* width: 100%; */
}
.Dashboard_date_chart_filter__waS4V {
  margin-right: 6px;
}

.Dashboard_charts_view__MeHlE {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  overflow-x: scroll;
  /* min-width: 1450px; */
  align-items: center;
  justify-content: space-between;
}

.Dashboard_bottom_disclaimer__aJWrB {
  margin: auto;
  margin-top: 3%;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/Dashboard/Dashboard.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;AACA;EACE,+DAA+D;AACjE;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".root {\n  padding: 15px 40px 90px 40px;\n  overflow: scroll;\n  margin-right: auto;\n  margin-left: auto;\n  height: 80vh;\n  color: var(--color-font-10);\n  font-size: 16px !important;\n  /* overflow-y: scroll !important; */\n}\n\n.upper {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-top: 2%;\n}\n\n.lower {\n  margin-top: 2%;\n}\n\n.settings_icon {\n  width: 2%;\n  margin: 1%;\n  float: right;\n  cursor: pointer;\n}\n.settings_icon:hover {\n  background-color: var(--color-bg-sidebar-item-hover) !important;\n}\n\n.loading_title {\n  position: fixed;\n  left: 50%;\n}\n\n.loading_label {\n  position: absolute;\n  left: 48%;\n  margin-top: 75px;\n}\n\n.kpi_container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  text-align: center;\n  width: 99%;\n  min-height: 150px;\n}\n\n.kpi_item {\n  width: 20%;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  margin-bottom: 3%;\n  cursor: pointer;\n}\n\n.kpi_value {\n  font-weight: bold;\n  font-size: 35px !important;\n  margin-bottom: 0% !important;\n  margin-top: 4% !important;\n}\n\n.kpi_name {\n  margin-top: 0% !important;\n  margin-bottom: 8% !important;\n}\n\n.chart_filters {\n  display: flex;\n  /* justify-content: space-between; */\n  align-items: center;\n}\n.chart_filter {\n  /* width: 15%; */\n  margin: 0 2%;\n}\n.date_chart_filters {\n  display: flex;\n  margin-right: 3%;\n  /* width: 100%; */\n}\n.date_chart_filter {\n  margin-right: 6px;\n}\n\n.charts_view {\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  overflow-x: scroll;\n  /* min-width: 1450px; */\n  align-items: center;\n  justify-content: space-between;\n}\n\n.bottom_disclaimer {\n  margin: auto;\n  margin-top: 3%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Dashboard_root__d2LZQ`,
	"upper": `Dashboard_upper__UIROX`,
	"lower": `Dashboard_lower__K0ehD`,
	"settings_icon": `Dashboard_settings_icon__jrPqZ`,
	"loading_title": `Dashboard_loading_title__sez9Z`,
	"loading_label": `Dashboard_loading_label__pOCOG`,
	"kpi_container": `Dashboard_kpi_container__+kA2O`,
	"kpi_item": `Dashboard_kpi_item__1JBQN`,
	"kpi_value": `Dashboard_kpi_value__hg1f3`,
	"kpi_name": `Dashboard_kpi_name__euXb3`,
	"chart_filters": `Dashboard_chart_filters__JkG8r`,
	"chart_filter": `Dashboard_chart_filter__IxUgW`,
	"date_chart_filters": `Dashboard_date_chart_filters__636uO`,
	"date_chart_filter": `Dashboard_date_chart_filter__waS4V`,
	"charts_view": `Dashboard_charts_view__MeHlE`,
	"bottom_disclaimer": `Dashboard_bottom_disclaimer__aJWrB`
};
export default ___CSS_LOADER_EXPORT___;
